import { type FC } from 'react'
import { TrialTimeline } from '../../Common/TrialTimeline'
import { type DeltaTrialTimelineProps } from '../Timeline/DeltaTrialTimeline'

export const ClientQueriesTimeline: FC<DeltaTrialTimelineProps> = (props) => {
  return <TrialTimeline featureName='Client Queries' {...props} />
}
